module.exports = __webpack_public_path__ + "static/media/08.8906a21f.jpg";